/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/351/interface/api/cat_732
 */

import { message } from 'ant-design-vue'
import {
  portal_user_list_get,
  portal_user_query_role_id_get,
  portal_user_delete_role_post,
  portal_user_create_role_post,
  portal_department_tree_get,
  portal_user_update_post,
  portal_user_hasAccess_get
} from 'server/modules/732'

// 查询列表
export const portal_user_list_get_ = async function(params) {
  const { success, data, retInfo } = await portal_user_list_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 角色详情查询
export const portal_user_query_role_id_get_ = async function(params) {
  const { success, data, retInfo } = await portal_user_query_role_id_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除
export const portal_user_delete_role_post_ = async function(params) {
  const { success, data, retInfo } = await portal_user_delete_role_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 批量分配
export const portal_user_create_role_post_ = async function(params) {
  const { success, data, retInfo } = await portal_user_create_role_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 部门组织树
export const portal_department_tree_get_ = async function(params) {
  const { success, data, retInfo } = await portal_department_tree_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 更新用户
export const portal_user_update_post_ = async function(params) {
  const { success, data, retInfo } = await portal_user_update_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 模拟登录权限查询
export const portal_user_hasAccess_get_ = async function(params) {
  const { success, data, retInfo } = await portal_user_hasAccess_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}
